@if(config().descriptionBlock?.isNullOrEmpty() === false) {
    <lsa-description-block [descriptionBlockConfig]="config().descriptionBlock!"></lsa-description-block>
}
@if (config().searchBox?.isNullOrEmpty() === false) {
    <lsa-searchbox
        [config]="config().searchBox!"
        (searchQueryChange)="this.searchQuery.set($event)">
    </lsa-searchbox>
}

<div class="carrousel-container">
    @if(showSpinner()){
        <mat-spinner></mat-spinner>
    }
    @else if (filteredVideos().length === 0) {
        {{ config().notFound }}
    } @else {
        <lsa-video-carrousel [videos]="filteredVideos()" [allVideosLoaded]="haveAllVideosBeenLoaded()" [resetLeftScroll$]="searchQueryChanged$"
        [moreVideosLoadedObservable]="videoBatchLoaded$" (moreVideosRequested)="loadVideos()"></lsa-video-carrousel>
    }
</div>
